export default __webpack_public_path__ + "static/media/Sergiyenkov_Dmitriy_Sergeyevich.f6513823.webp";